import type { ChromeTranslations } from '../types';

export const en: ChromeTranslations = {
  'nav.nextPage': 'next page →',
  'nav.previousPage': '← previous page',
  'nav.continueToLevel': 'continue to level →',
  'nav.backToMenu': 'back to menu →',
  'howto.page': 'page {n} of {total}',
  'options.title': 'Options',
  'ui.language': 'Language',
};
